module.exports = __webpack_public_path__ + "static/media/education-combined.b6ca8add.jpg";